<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa fa-whatsapp"></i>
    Mensagem de WhatsApp
    <span class="sub">{{ isEditing ? 'editando' : campaign?.name }}</span>
  </h4>
  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="activeModal.dismiss('close')"
          data-testid="wa-close">
    <i class="fa fa-times"></i>
  </button>
</div>

<div class="modal-body wa-modal">
  <ol class="stepper" data-testid="wa-stepper">
    <ng-container *ngFor="let label of steps; let i = index; let last = last">
      <li [class.on]="step === i + 1" [class.done]="step > i + 1">
        <!-- Lápis nos passos que dá para abrir: o cliente vê que o stepper é clicável (Bruno, 13/10/2026). -->
        <button type="button" (click)="goTo(i + 1)" [disabled]="!canGoTo(i + 1)" [attr.data-testid]="'wa-step-' + (i + 1)"
                [class.editable]="step !== i + 1 && canGoTo(i + 1)"
                [attr.title]="step !== i + 1 && canGoTo(i + 1) ? 'Editar: ' + label : null">
          <span class="n">{{ i + 1 }}</span><span class="lbl">{{ label }}</span>
          <i class="fa fa-pencil edit-ico" *ngIf="step !== i + 1 && canGoTo(i + 1)" aria-hidden="true"
             [attr.data-testid]="'wa-stepper-edit-' + (i + 1)"></i>
        </button>
      </li>
      <span class="line" *ngIf="!last" [class.done]="step > i + 1"></span>
    </ng-container>
  </ol>

  <div class="notice notice--danger notice--sm" *ngIf="saveError" data-testid="wa-save-error">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="notice__body"><span>{{ saveError }}</span></div>
  </div>

  <div class="notice notice--danger notice--sm" *ngIf="showErrors(step)" data-testid="wa-step-errors">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="notice__body"><span *ngFor="let e of stepErrors(step)">{{ e }}</span></div>
  </div>

  <!-- 1 · Número ----------------------------------------------------------------------- -->
  <section *ngIf="step === 1" data-testid="wa-pane-1">
    <p class="section-hint">Por qual número este passo envia? Templates, variáveis e agentes dos próximos passos vêm do número escolhido.</p>

    <app-skeleton *ngIf="loadingAccounts" variant="text" [count]="3" label="Carregando seus números"></app-skeleton>

    <div class="notice notice--danger" *ngIf="!loadingAccounts && accountsError">
      <i class="fa fa-exclamation-triangle"></i>
      <div class="notice__body"><span>Não foi possível carregar seus números.</span></div>
      <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="loadAccounts()">Tentar de novo</button>
    </div>

    <div class="empty" *ngIf="!loadingAccounts && !accountsError && !accounts.length" data-testid="wa-no-accounts">
      <i class="fa fa-whatsapp"></i>
      <h3>Nenhum número conectado</h3>
      <p>Para enviar WhatsApp nas automações, conecte um número da sua conta Meta em <strong>WhatsApp → Integrações WhatsApp</strong>.</p>
      <a class="sf-btn sf-btn--primary sf-btn--sm" [routerLink]="['/whatsapp-integration']" target="_blank" rel="noopener"
         data-testid="wa-link-connect">
        <i class="fa fa-whatsapp"></i> Conectar WhatsApp <i class="fa fa-external-link"></i>
      </a>
    </div>

    <div class="pick-grid" *ngIf="!loadingAccounts && accounts.length">
      <button type="button" class="pick" *ngFor="let account of accounts"
              [class.on]="account.id === accountId" [disabled]="!isSelectable(account)"
              (click)="selectAccount(account)" [attr.data-testid]="'wa-account-' + account.id">
        <span class="pk-ic" [class.danger]="isBroken(account)" [class.muted]="!isSelectable(account)"><i class="fa fa-whatsapp"></i></span>
        <span class="pk-body">
          <span class="pk-t">{{ account.name }}
            <span class="status-pill status-pill--sm" [ngClass]="'status-pill--' + account.status">{{ statusLabel(account) }}</span>
          </span>
          <span class="pk-s">{{ accountHint(account) }}</span>
        </span>
        <i class="fa fa-check-circle pk-check" *ngIf="account.id === accountId"></i>
      </button>
    </div>

    <div class="notice notice--danger notice--sm wa-gap" *ngIf="isBroken(selectedAccount)" data-testid="wa-account-broken">
      <i class="fa fa-exclamation-triangle"></i>
      <div class="notice__body"><span>Dá para salvar com este número, mas <strong>nada sai até você trocar o token</strong>. Os envios ficam agendados.</span></div>
      <a class="sf-btn sf-btn--secondary sf-btn--sm" [routerLink]="['/whatsapp-integration', accountId]" [queryParams]="{ tab: 'conexao' }"
         target="_blank" rel="noopener" data-testid="wa-link-reconnect">
        <i class="fa fa-key"></i> Reconectar <i class="fa fa-external-link"></i>
      </a>
    </div>

    <!-- Com um número conectado só, não há "outro" a oferecer aqui (Bruno, 09/10). -->
    <div class="wa-actions" *ngIf="showAddNumber">
      <a class="sf-btn sf-btn--ghost sf-btn--sm" [routerLink]="['/whatsapp-integration']" target="_blank" rel="noopener" data-testid="wa-add-number">
        <i class="fa fa-plus-circle"></i> Adicionar outro número <i class="fa fa-external-link"></i>
      </a>
    </div>
  </section>

  <!-- 2 · Template --------------------------------------------------------------------- -->
  <section *ngIf="step === 2" data-testid="wa-pane-2">
    <app-skeleton *ngIf="loadingTemplates" variant="text" [count]="4"
      [label]="'Carregando os templates aprovados de ' + (selectedAccount?.name || '')"></app-skeleton>

    <ng-container *ngIf="!loadingTemplates && templatesError">
      <div class="notice notice--danger" data-testid="wa-templates-error">
        <i class="fa fa-exclamation-triangle"></i>
        <div class="notice__body"><strong>Token recusado</strong><span>Não foi possível listar os templates: {{ templatesError }}</span></div>
      </div>
      <div class="wa-actions">
        <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="loadTemplates()"><i class="fa fa-refresh"></i> Tentar de novo</button>
        <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="goTo(1)"><i class="fa fa-arrow-left"></i> Escolher outro número</button>
      </div>
    </ng-container>

    <ng-container *ngIf="!loadingTemplates && !templatesError && !approvedTemplates.length && !templateName">
      <div class="notice notice--warning" data-testid="wa-no-templates">
        <i class="fa fa-exclamation-triangle"></i>
        <div class="notice__body">
          <strong>Sem template aprovado neste número</strong>
          <span>O número <strong>{{ selectedAccount?.name }}</strong> não tem template aprovado. A primeira mensagem de WhatsApp fora da janela de 24h <strong>exige</strong> template aprovado pela Meta.</span>
        </div>
      </div>
      <div class="empty">
        <i class="fa fa-file-text-o"></i>
        <p>Crie o template na integração e volte aqui. A aprovação da Meta costuma levar de minutos a algumas horas.</p>
        <div class="wa-actions">
          <a class="sf-btn sf-btn--primary sf-btn--sm" [routerLink]="['/whatsapp-integration', accountId]" [queryParams]="{ tab: 'templates' }"
             target="_blank" rel="noopener" data-testid="wa-link-create-template">
            <i class="fa fa-file-text-o"></i> Criar template em {{ selectedAccount?.name }} <i class="fa fa-external-link"></i>
          </a>
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="loadTemplates()"><i class="fa fa-refresh"></i> Já criei, atualizar</button>
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="goTo(1)"><i class="fa fa-arrow-left"></i> Escolher outro número</button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!loadingTemplates && (approvedTemplates.length || templateName)">
      <p class="section-hint" *ngIf="!templatesError">Só aparecem os templates <strong>aprovados</strong> do número <strong>{{ selectedAccount?.name }}</strong>. É o template que abre a conversa fora da janela de 24h da Meta.</p>
      <div class="two-col two-col--tpl">
        <div>
          <div class="field">
            <div class="field-head">
              <label for="wa-template">Template da primeira mensagem</label>
              <a class="sf-btn sf-btn--ghost sf-btn--sm" [routerLink]="['/whatsapp-integration', accountId]" [queryParams]="{ tab: 'templates' }"
                 target="_blank" rel="noopener" data-testid="wa-link-manage-templates">
                <i class="fa fa-external-link"></i> Gerenciar templates
              </a>
            </div>
            <select id="wa-template" class="form-select" [ngModel]="selectedTemplateKey" (ngModelChange)="selectTemplate($event)" data-testid="wa-select-template">
              <option [ngValue]="null">Selecione o template…</option>
              <option *ngIf="savedTemplateMissing" [ngValue]="selectedTemplateKey" data-testid="wa-saved-template-option">{{ templateName }} · salvo neste passo{{ templatesError ? '' : ' (fora dos aprovados)' }}</option>
              <option *ngFor="let tpl of approvedTemplates" [ngValue]="templateKey(tpl)">{{ tpl.name }} · {{ tpl.category | titlecase }} · {{ tpl.language }}</option>
              <option *ngFor="let tpl of pendingTemplates" [ngValue]="templateKey(tpl)" disabled>{{ tpl.name }} · em análise na Meta (indisponível)</option>
            </select>
            <span class="field-hint" *ngIf="!templatesError">{{ approvedTemplates.length }} aprovado{{ approvedTemplates.length === 1 ? '' : 's' }}<span *ngIf="pendingTemplates.length"> · {{ pendingTemplates.length }} em análise</span>. Falta algum?
              <a [routerLink]="['/whatsapp-integration', accountId]" [queryParams]="{ tab: 'templates' }" target="_blank" rel="noopener" data-testid="wa-link-create-in-integration">Crie na integração <i class="fa fa-external-link"></i></a>.</span>
          </div>

          <div class="notice notice--warning notice--sm" *ngIf="savedTemplateMissing" data-testid="wa-saved-template-warning">
            <i class="fa fa-exclamation-triangle"></i>
            <div class="notice__body">
              <span *ngIf="templatesError">Não deu para conferir na Meta agora. O template <strong>{{ templateName }}</strong> continua salvo neste passo; confira se ele segue aprovado quando a integração voltar.</span>
              <span *ngIf="!templatesError">O template <strong>{{ templateName }}</strong> não está mais entre os aprovados de {{ selectedAccount?.name }}: a Meta recusaria o envio. Escolha um aprovado para salvar o passo.</span>
            </div>
          </div>
          <p class="field-hint" *ngIf="savedTemplateMissing && variablesSummary.length" data-testid="wa-saved-template-vars">
            Variáveis salvas: <span *ngFor="let v of variablesSummary; let last = last">{{ v.label }} = {{ v.value }}{{ last ? '' : ' · ' }}</span>
          </p>

          <ng-container *ngIf="templateName && slots.length">
            <div class="lbl-u">Variáveis do template</div>
            <p class="field-hint">Escolha o que vai em cada variável: um dado do lead ou um texto fixo. A Meta recusa variável em branco: lead sem o dado não recebe e o motivo aparece na linha do tempo dele.</p>

            <div class="notice notice--warning notice--sm" *ngIf="defaultedVariables.length" data-testid="wa-var-defaulted">
              <i class="fa fa-exclamation-triangle"></i>
              <div class="notice__body"><span>Este passo foi salvo sem escolher o dado de {{ defaultedVariables.length === 1 ? 'uma variável' : 'algumas variáveis' }} de nome: estamos usando o <strong>primeiro nome do lead</strong>. Confira e salve.</span></div>
            </div>

            <div class="var-map" data-testid="wa-var-map">
              <div class="var-row" *ngFor="let slot of slots" [attr.data-testid]="'wa-var-row-' + slot.key">
                <label class="var-name" [for]="'wa-var-' + slot.key">
                  <code>{{ slot.label }}</code>
                  <span class="var-ex" *ngIf="slot.example">ex.: {{ slot.example }}</span>
                  <span class="badge-soft" *ngIf="isDefaulted(slot)" data-testid="wa-var-default-badge">padrão</span>
                </label>
                <div class="var-value">
                  <ng-container *ngIf="!isMediaSlot(slot); else mediaInput">
                    <select class="form-select" [id]="'wa-var-' + slot.key" [ngModel]="slotChoice(slot)" (ngModelChange)="setSlotChoice(slot, $event)"
                            [attr.data-testid]="'wa-select-var-' + slot.key">
                      <option value="">Selecione…</option>
                      <optgroup label="Dado do lead">
                        <option *ngFor="let v of variableOptions" [value]="v.token">{{ v.label }}</option>
                      </optgroup>
                      <option [value]="fixedChoice">Texto fixo…</option>
                    </select>
                    <input *ngIf="slotChoice(slot) === fixedChoice" type="text" class="form-control" maxlength="1000"
                           [ngModel]="slotFixedText(slot)" (ngModelChange)="setSlotFixed(slot, $event)"
                           placeholder="Texto que vai para todos os leads" [attr.data-testid]="'wa-fixed-var-' + slot.key" />
                  </ng-container>
                  <ng-template #mediaInput>
                    <input type="url" class="form-control" [id]="'wa-var-' + slot.key" [ngModel]="slotFixedText(slot)" (ngModelChange)="setSlotFixed(slot, $event)"
                           placeholder="https://… (link público do arquivo)" [attr.data-testid]="'wa-fixed-var-' + slot.key" />
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="notice notice--success notice--sm" *ngIf="usesLinkInTemplate" data-testid="wa-var-link">
              <i class="fa fa-check-circle"></i>
              <div class="notice__body"><span>Você usou <strong>Meu link</strong> numa variável do template: o campo “Meu link” aparece no próximo passo.</span></div>
            </div>
          </ng-container>
        </div>

        <div class="wa-preview" *ngIf="selectedTemplate">
          <div class="lbl"><i class="fa fa-mobile"></i> Prévia · primeira mensagem (template)</div>
          <div class="bubble" data-testid="wa-template-preview"><strong class="bubble-head" *ngIf="templateHeaderPreview" data-testid="wa-template-header-preview">{{ templateHeaderPreview }}</strong>{{ templatePreview }}<span class="t">10:42</span></div>
          <div class="bubble-buttons" *ngIf="templateButtons.length">
            <span *ngFor="let b of templateButtons">{{ b }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </section>

  <!-- 3 · Mensagem --------------------------------------------------------------------- -->
  <section *ngIf="step === 3" data-testid="wa-pane-3">
    <p class="section-hint">Esta é a mensagem <strong>opcional</strong> que o lead recebe se responder ao template. É aqui que entram as tags, inclusive <strong>{{ '{' }}meu_link{{ '}' }}</strong>.</p>

    <div class="wa-gap">
      <button type="button" class="wa-switch" [class.on]="followup" (click)="followup = !followup" data-testid="wa-toggle-followup">
        <span class="track"></span><span>Enviar uma mensagem quando o lead responder ao template</span>
      </button>
    </div>

    <div *ngIf="followup">
      <div class="notice notice--sm">
        <i class="fa fa-info-circle"></i>
        <div class="notice__body"><span>A Meta só aceita texto livre nas <strong>24h seguintes a uma resposta do lead</strong>. Se o lead responder ao template dentro do prazo abaixo, mandamos esta mensagem em seguida (outra mensagem cobrada do saldo da carteira). Sem resposta, só o template é enviado. Se a conversa com o lead <strong>já estiver aberta</strong> quando o passo disparar (ele escreveu nas últimas 24h), sai só esta mensagem, no lugar do template.</span></div>
      </div>

      <div class="two-col two-col--msg">
        <div>
          <div class="field">
            <label for="wa-text">Mensagem (até 4.096 caracteres, pode usar emoji)</label>
            <textarea id="wa-text" class="form-control" rows="5" [(ngModel)]="text" [maxlength]="textMax"
                      (blur)="setCursor($event)" (keyup)="setCursor($event)" (click)="setCursor($event)"
                      placeholder="Ex.: Oi {first_name}! Separei seu carrinho com o cupom VOLTA10 😉 Finalize aqui: {meu_link}"
                      data-testid="wa-text"></textarea>
            <span class="counter">{{ (text || '').length }}/{{ textMax }}</span>
          </div>

          <div class="field-grid field-grid--2">
            <div class="field">
              <label for="wa-window">Prazo para a resposta do lead</label>
              <input id="wa-window" type="number" min="1" class="form-control" [(ngModel)]="followupWindow" data-testid="wa-window" />
            </div>
            <div class="field">
              <label for="wa-window-type">Unidade</label>
              <select id="wa-window-type" class="form-select" [(ngModel)]="followupWindowType">
                <option *ngFor="let t of followupIntervalTypes" [ngValue]="t.id">{{ t.name }}</option>
              </select>
            </div>
          </div>
          <p class="field-hint wa-tight">No máximo 23h59. Desligue o envio acima para mandar só o template.</p>
        </div>

        <div>
          <div class="field">
            <label>Variáveis</label>
            <div class="tags-wrap">
              <button type="button" class="tag" *ngFor="let tag of tags" [title]="tag.title" (click)="insertTag(tag.tag)">{{ tag.tag }}</button>
            </div>
            <span class="field-hint">Clique para inserir. Os dados vêm do lead; {{ '{' }}meu_link{{ '}' }} vem deste passo.</span>
          </div>
          <div class="wa-preview wa-gap-top">
            <div class="lbl"><i class="fa fa-mobile"></i> Prévia ao vivo</div>
            <div class="bubble in">Oi, ainda tem?<span class="t">10:50</span></div>
            <div class="bubble" data-testid="wa-text-preview">{{ textPreview || 'Sua mensagem aparece aqui…' }}<span class="t">10:51</span></div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="needsLink" data-testid="wa-link-field">
      <div class="field">
        <label for="wa-url">Meu link</label>
        <input id="wa-url" type="text" class="form-control" placeholder="https://exemplo.com" [(ngModel)]="url" data-testid="wa-url" />
        <span class="field-hint">Encurtado automaticamente no lugar de {{ '{' }}meu_link{{ '}' }}. Também vale para a variável “Meu link” do template.</span>
      </div>
      <div class="wa-gap-top">
        <button type="button" class="wa-switch" [class.on]="sendLeadNumber" (click)="sendLeadNumber = !sendLeadNumber"
                role="switch" [attr.aria-checked]="sendLeadNumber" data-testid="wa-toggle-send-lead-number">
          <span class="track"></span><span>Enviar número do lead na URL</span>
        </button>
        <p class="field-hint wa-tight">Ligado, o link de cada lead leva o telefone dele (<code>var_phone</code>), para a sua página saber quem clicou.</p>
      </div>
    </div>
    <p class="field-hint" *ngIf="followup && !needsLink" data-testid="wa-link-hint">
      <i class="fa fa-info-circle"></i> Quer um link? Use a tag <strong>{{ '{' }}meu_link{{ '}' }}</strong> e o campo “Meu link” aparece aqui.
    </p>
  </section>

  <!-- 4 · Responder com IA -------------------------------------------------------------- -->
  <section *ngIf="step === 4" data-testid="wa-pane-4">
    <div class="notice notice--violet notice--sm" *ngIf="!aiAvailable" data-testid="wa-ai-unavailable">
      <i class="fa fa-magic"></i>
      <div class="notice__body"><span>A IA não está habilitada na sua conta. As respostas do lead chegam em <strong>WhatsApp → Conversas</strong> para a sua equipe.</span></div>
    </div>
    <p class="field-hint" *ngIf="!aiAvailable && keepsSavedAgent" data-testid="wa-ai-kept-agent">
      Este passo tem o agente <strong>{{ sequence?.ai_agent?.name || 'escolhido antes' }}</strong>. Ele continua no passo e volta a responder quando a IA for liberada na conta.
    </p>

    <ng-container *ngIf="aiAvailable">
      <div class="wa-gap">
        <button type="button" class="wa-switch" [class.on]="ai" (click)="toggleAi()" data-testid="wa-toggle-ai">
          <span class="track"></span><span>Responder com IA</span>
        </button>
      </div>


      <div class="notice notice--sm" *ngIf="!ai">
        <i class="fa fa-info-circle"></i>
        <div class="notice__body"><span>Sem IA, as respostas do lead chegam em <strong>WhatsApp → Conversas</strong> para alguém da sua equipe responder.</span></div>
      </div>

      <div *ngIf="ai">
        <p class="section-hint">Quando o lead responder, este agente assume a conversa. Aparecem os agentes do número <strong>{{ selectedAccount?.name }}</strong> e os sem número, que respondem por qualquer um.</p>

        <app-skeleton *ngIf="loadingAgents" variant="text" [count]="3" label="Carregando os agentes do número"></app-skeleton>

        <ng-container *ngIf="!loadingAgents && agentsError">
          <div class="notice notice--danger" data-testid="wa-agents-error">
            <i class="fa fa-exclamation-triangle"></i>
            <div class="notice__body"><span>Não foi possível carregar os agentes deste número.</span></div>
          </div>
          <div class="wa-actions">
            <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="loadAgents()" data-testid="wa-agents-retry"><i class="fa fa-refresh"></i> Tentar de novo</button>
          </div>
        </ng-container>

        <div class="empty" *ngIf="!loadingAgents && !agentsError && !agents.length" data-testid="wa-no-agents">
          <i class="fa fa-android"></i>
          <p>Nenhum agente responde pelo número <strong>{{ selectedAccount?.name }}</strong> ainda.</p>
          <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="openQuickAgent()" data-testid="wa-create-agent">
            <i class="fa fa-plus-circle"></i> Criar agente para este número
          </button>
        </div>

        <ng-container *ngIf="!loadingAgents && agents.length">
          <div class="agent-search">
            <i class="fa fa-search"></i>
            <input type="search" class="form-control" placeholder="Buscar agente pelo nome" [ngModel]="agentSearch"
                   (ngModelChange)="searchAgents($event)" aria-label="Buscar agente pelo nome" data-testid="wa-agent-search" />
          </div>

          <p class="field-hint" *ngIf="!filteredAgents.length" data-testid="wa-agent-search-empty">Nenhum agente com “{{ agentSearch }}”.</p>

          <div class="pick-grid">
            <div class="pick-row" *ngFor="let agent of pagedAgents" [attr.data-testid]="'wa-agent-row-' + agent.id">
              <button type="button" class="pick" [class.on]="agent.id === agentId" [disabled]="!isAgentSelectable(agent)"
                      (click)="selectAgent(agent)" [attr.data-testid]="'wa-agent-' + agent.id">
                <span class="radio"></span>
                <span class="pk-ic" [class.ai]="agent.active" [class.muted]="!agent.active"><i class="fa fa-android"></i></span>
                <span class="pk-body">
                  <span class="pk-t">{{ agent.name }}
                    <span class="status-pill status-pill--sm status-pill--danger" *ngIf="!agent.active"
                          [attr.data-testid]="'wa-agent-inactive-' + agent.id">Inativo</span>
                    <span class="status-pill status-pill--sm status-pill--disabled" *ngIf="!agent.meta_whatsapp_account_id"
                          [attr.data-testid]="'wa-agent-unassigned-' + agent.id">Sem número</span>
                  </span>
                  <span class="pk-s" [attr.data-testid]="'wa-agent-status-' + agent.id">{{ agentStatusText(agent) }} · {{ promptExcerpt(agent) }}</span>
                </span>
              </button>
              <div class="pick-actions">
                <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" [ngbPopover]="integrationsPop" popoverTitle="Integrações do agente"
                        placement="left auto" container="body" popoverClass="wa-agent-pop" [autoClose]="'outside'"
                        [attr.data-testid]="'wa-agent-integrations-' + agent.id" aria-label="Integrações do agente">
                  <i class="fa fa-whatsapp"></i> Integrações
                </button>
                <ng-template #integrationsPop>
                  <ul class="agent-integrations" [attr.data-testid]="'wa-agent-integrations-list-' + agent.id">
                    <li *ngFor="let line of agentIntegrations(agent)">
                      <i class="fa fa-whatsapp"></i>
                      <span><strong>{{ line.name }}</strong><span *ngIf="line.phone"> · {{ line.phone }}</span>
                        <em *ngIf="line.note"> · {{ line.note }}</em></span>
                    </li>
                  </ul>
                </ng-template>
                <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm sf-btn--icon" (click)="openQuickAgent(agent)" ngbTooltip="Copiar agente"
                        container="body" [attr.data-testid]="'wa-agent-copy-' + agent.id" aria-label="Copiar agente">
                  <i class="fa fa-copy"></i>
                </button>
              </div>
            </div>
            <button type="button" class="pick" (click)="openQuickAgent()" data-testid="wa-create-agent">
              <span class="radio"></span>
              <span class="pk-ic"><i class="fa fa-plus-circle"></i></span>
              <span class="pk-body">
                <span class="pk-t">Criar um agente novo</span>
                <span class="pk-s">Abre um formulário curto, já com o número {{ selectedAccount?.name }}, para criar e testar. Ao salvar, ele volta selecionado aqui.</span>
              </span>
            </button>
          </div>

          <div class="agent-pager" *ngIf="agentPageCount > 1" data-testid="wa-agent-pager">
            <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm sf-btn--icon" (click)="setAgentPage(agentPage - 1)" [disabled]="agentPage <= 1"
                    aria-label="Página anterior" data-testid="wa-agent-prev"><i class="fa fa-chevron-left"></i></button>
            <span>Página {{ agentPage }} de {{ agentPageCount }} · {{ filteredAgents.length }} agentes</span>
            <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm sf-btn--icon" (click)="setAgentPage(agentPage + 1)" [disabled]="agentPage >= agentPageCount"
                    aria-label="Próxima página" data-testid="wa-agent-next"><i class="fa fa-chevron-right"></i></button>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </section>

  <!-- 5 · Resumo ------------------------------------------------------------------------ -->
  <section *ngIf="step === 5" data-testid="wa-pane-5">
    <p class="section-hint">Confira e salve. Para mudar algo, clique no lápis do bloco (ou no passo, lá em cima): ao continuar, você volta para cá.</p>

    <div class="field-grid field-grid--2">
      <div class="field">
        <label for="wa-interval">Enviar após entrada na lista</label>
        <input id="wa-interval" type="number" min="0" class="form-control" [(ngModel)]="interval" data-testid="wa-interval" />
      </div>
      <div class="field">
        <label for="wa-interval-type">Unidade</label>
        <select id="wa-interval-type" class="form-select" [(ngModel)]="intervalType" data-testid="wa-interval-type">
          <option *ngFor="let t of intervalTypes" [ngValue]="t.id">{{ t.name }}</option>
        </select>
      </div>
    </div>

    <div class="summary" data-testid="wa-summary">
      <div class="s">
        <div class="l">Número <button type="button" class="s-edit" (click)="editFromSummary(1)" aria-label="Editar número" data-testid="wa-edit-1"><i class="fa fa-pencil"></i></button></div>
        <div class="v"><i class="fa fa-whatsapp"></i>{{ selectedAccount?.name || '—' }}<span *ngIf="selectedAccount?.display_phone_number"> · {{ selectedAccount.display_phone_number }}</span></div>
      </div>
      <div class="s">
        <div class="l">Quando <button type="button" class="s-edit" (click)="editFromSummary(5)" aria-label="Editar quando enviar" data-testid="wa-edit-5"><i class="fa fa-pencil"></i></button></div>
        <div class="v"><i class="fa fa-clock-o"></i>{{ interval }} {{ intervalTypeName }} após entrar na lista</div>
      </div>
      <div class="s wide">
        <div class="l">Primeira mensagem (template) <button type="button" class="s-edit" (click)="editFromSummary(2)" aria-label="Editar template" data-testid="wa-edit-2"><i class="fa fa-pencil"></i></button></div>
        <div class="v"><i class="fa fa-file-text-o"></i>{{ templateName || '—' }}
          <span *ngFor="let v of variablesSummary" data-testid="wa-summary-var"> · {{ v.label }} = {{ v.value }}</span>
        </div>
      </div>
      <div class="s wide">
        <div class="l">{{ followup ? 'Se o lead responder em até ' + followupWindow + ' ' + followupTypeName : 'Se o lead responder' }} <button type="button" class="s-edit" (click)="editFromSummary(3)" aria-label="Editar mensagem" data-testid="wa-edit-3"><i class="fa fa-pencil"></i></button></div>
        <div class="v"><i class="fa fa-comment"></i>
          <span *ngIf="followup">“{{ text }}”</span>
          <span *ngIf="!followup">Nenhuma mensagem automática — só o template</span>
          <span class="chip" *ngIf="needsLink"><i class="fa fa-link"></i> Meu link: {{ url }}</span>
        </div>
      </div>
      <div class="s wide">
        <div class="l">Responder com IA <button type="button" class="s-edit" (click)="editFromSummary(4)" aria-label="Editar resposta com IA" data-testid="wa-edit-4"><i class="fa fa-pencil"></i></button></div>
        <div class="v"><i class="fa fa-magic"></i>{{ ai && selectedAgent ? selectedAgent.name : 'Desligado — resposta humana em Conversas' }}</div>
      </div>
    </div>
  </section>
</div>

<div class="modal-footer">
  <button type="button" class="sf-btn sf-btn--ghost push" (click)="activeModal.dismiss('cancel')" data-testid="wa-cancel">Cancelar</button>
  <button type="button" class="sf-btn sf-btn--secondary" (click)="back()" [disabled]="step === 1" data-testid="wa-back">
    <i class="fa fa-arrow-left"></i> Voltar
  </button>
  <button type="button" class="sf-btn sf-btn--primary sf-btn--icon-right" *ngIf="step < steps.length" (click)="next()"
          [disabled]="step === 1 && !loadingAccounts && !accounts.length" data-testid="wa-next">
    {{ returnToSummary ? 'Continuar para o resumo' : 'Continuar' }} <i class="fa fa-arrow-right"></i>
  </button>
  <button type="button" class="sf-btn sf-btn--primary" *ngIf="step === steps.length" (click)="save()" [appLoadingButton]="saving" data-testid="wa-save">
    <i class="fa fa-save"></i> Salvar na sequência
  </button>
</div>
